module.exports = __webpack_public_path__ + "img/dump-truck.5a71c607.jpg";